<template>
    <AdminsList />
</template>

<script>
import {
    mapActions
} from 'vuex'

import AdminsList from '../components/AdminPanelAdminsList.vue'

export default {
    data: () => ({}),
    components: {
        AdminsList
    },
    methods: {
    },
    mounted() {
    }
}
</script>
